import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-selection-challenge-type-dialog",
  templateUrl: "./selection-challenge-type-dialog.component.html",
  styleUrls: [
    "./selection-challenge-type-dialog.component.css",
    "../../../../modules/pos/modules/challenges/components/challenge-type-selection/challenge-type-selection.component.css",
  ],
})
export class SelectionChallengeTypeDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<SelectionChallengeTypeDialogComponent>
  ) {}

  typeOfChallenges = [
    {
      displayName: "Milestone",
      description:
        "A milestone-based challenge is a progressive system where users complete tasks to advance through increasing difficulty levels.",
      value: "MILESTONE",
    },
    {
      displayName: "Reward",
      description:
        "Reward node to give rewards to the customer",
      value: "REWARD",
    },
  ];
  selectedChallenge = "MILESTONE";
  videoUrl: string =
    "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4";

  ngOnInit(): void {}

  selectType(value) {
    this.selectedChallenge = value;
  }

  selectChallengeType(value) {
    this.dialogRef.close(value);
  }
}
